import { Reducer, useReducer } from 'react'

export function useToggle(defaultValue = false) {
  return useReducer<Reducer<boolean, void>>((value) => !value, defaultValue)
}
